module.exports = __webpack_public_path__ + "static/media/line-size-6.da532ada.svg";